import React from 'react';
import { NavLink } from 'react-router-dom';
import { HiOutlineDocumentText, HiOutlinePhotograph, HiOutlineCog } from 'react-icons/hi';

export default function AdminBlogSidebar() {
  return (
    <aside className="adminblog-sidebar">
      <div className="adminblog-sidebar-brand">
        <h2>The Journal</h2>
        <span>Blog Admin</span>
      </div>
      <NavLink to="/adminblog/posts" className={({ isActive }) => `adminblog-nav-item ${isActive ? 'active' : ''}`}>
        <span className="adminblog-nav-icon"><HiOutlineDocumentText /></span>
        Posts
      </NavLink>
      <NavLink to="/adminblog/media" className={({ isActive }) => `adminblog-nav-item ${isActive ? 'active' : ''}`}>
        <span className="adminblog-nav-icon"><HiOutlinePhotograph /></span>
        Media
      </NavLink>
      <NavLink to="/adminblog/settings" className={({ isActive }) => `adminblog-nav-item ${isActive ? 'active' : ''}`}>
        <span className="adminblog-nav-icon"><HiOutlineCog /></span>
        Settings
      </NavLink>
    </aside>
  );
}
